import { createSelector } from 'reselect';
import { getTravelKe } from './index';
import { FORM_STATUS, API_CALL_STATUS } from '../../reducers/status';

export const getTravelDetails = createSelector(getTravelKe, (state) => state.travelDetails);

export const getTravelDetailsForm = createSelector(getTravelDetails, (travelDetails) => travelDetails.form);
export const getTravelDetailsEmergency = createSelector(getTravelDetails, (travelDetails) => travelDetails.emergency);

export const getDropOffDetails = createSelector(getTravelDetails, (travelDetails) => travelDetails.dropOffDetails);

export const getTravelDetailsFormValid = createSelector(
    getTravelDetails,
    (travelDetails) => travelDetails.formStatus === FORM_STATUS.VALID
);

export const getPersonalDetailsId = createSelector(getTravelDetails, (travelDetails) => travelDetails.personalDetailId);

export const getIsApiPending = createSelector(
    getTravelDetails,
    (travelDetails) => travelDetails.formStatus === API_CALL_STATUS.PENDING
);

export const getTrallers = createSelector(getTravelDetails, (travelDetails) => travelDetails.travellers);
export const getCurrentTravellerIndex = createSelector(
    getTravelDetails,
    (travelDetails) => travelDetails.currentTravellerIndex
);
const makeGetFieldForm = (fieldId) => createSelector(getTravelDetailsForm, (form) => form[fieldId]);
const makeGetFieldEmergency = (fieldId) => createSelector(getTravelDetailsEmergency, (emergency) => emergency[fieldId]);

export const getDOBValue = makeGetFieldForm('dob');
export const getAgeBandValue = makeGetFieldForm('ageBand');
export const getTitleValue = makeGetFieldForm('title');
export const getFullNameValue = makeGetFieldForm('fullName');
export const getIdTypeValue = makeGetFieldForm('idType');
export const getKraNumberValue = makeGetFieldForm('kraNumber');
export const getEmailValue = makeGetFieldForm('email');
export const getIdNumberValue = makeGetFieldForm('idNumber');
export const getPassportValue = makeGetFieldForm('passport');
export const getPhoneNumberValue = makeGetFieldForm('phoneNumber');
export const getIdDocValue = makeGetFieldForm('idDoc');
export const getKraPinDocValue = makeGetFieldForm('kraPinDoc');
export const getPassportDocValue = makeGetFieldForm('passportDoc');
export const getTravellerIdValue = makeGetFieldForm('travellerId');

export const getFullNameEmergencyValue = makeGetFieldEmergency('fullName');
export const getEmailEmergencyValue = makeGetFieldEmergency('email');
export const getPhoneNumberEmergencyValue = makeGetFieldEmergency('phoneNumber');

export const getReferredValue = makeGetFieldForm('referred');
